export enum RoundStakingStatus {
    ON = 0,
    OFF = 1,
    ENDED = 2,
    CANCELED = 3
}

export enum RoundType {
    PUBLIC = 0,
    PRIVATE = 1
}

export enum StakingType {
    AUTOMATIC = 0,
    MANUAL = 1
}

export type StakingData = {
    stakingStatus: RoundStakingStatus;
    stakingType: StakingType;
    cliffPeriod: number;
    vestingPeriod: number;
    endStaking: number;
    stakingRewardPercentage: number;
    createdAt: number;
}

export type StakingInfo = {
    stakingId: string;
    stakingDetails: StakingData;
}

export type UserRound = {
    saleRoundId: string;
    stakingRoundId: string;
}

export type Stake = {
    amount: number;
    createdAt: number;
}

// Helpers
export const toRoundStatus = (status: number): string => {
    return RoundStakingStatus[status];
}

export const toRoundType = (type: number): string => {
    return RoundType[type];
}

export const isRoundStatus = (roundStatus: RoundStakingStatus, testRoundStatus: RoundStakingStatus): boolean => {
    const roundStatusAsBigint = roundStatus as any as bigint;
    return Number(roundStatusAsBigint) === testRoundStatus;
}

// export const isPublicRound = (roundType: bigint): boolean => isRoundType(roundType, RoundType.PUBLIC);
// export const isPrivateRound = (roundType: bigint): boolean => isRoundType(roundType, RoundType.PRIVATE);
export const isRoundType = (roundType: RoundType, testRoundType: RoundType): boolean => {
    const roundTypeAsBigint = roundType as any as bigint;
    return Number(roundTypeAsBigint) === testRoundType;
}

export const toStackingType = (type: number): string => {
    return StakingType[type];
}

export const toRoundStatusNumber = (status: string): number => {
    return RoundStakingStatus[status as keyof typeof RoundStakingStatus];
} 

export const isStakingType = (stakingType: StakingType, testStakingType: StakingType): boolean => {
    const stakingTypeAsBigint = stakingType as any as bigint;
    return Number(stakingTypeAsBigint) === testStakingType;
}